import { Component } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";
import { AlertController } from "ionic-angular";
import { Hareline } from "../../models/interfaces/hareline.model";
import { Member } from "../../models/interfaces/member.model";
import { Songs } from "../../models/interfaces/songs.model";
import { SongsPage } from "../../pages/songs/songs";
import { SongsUpdatePage } from "../../pages/songs/songs_update";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-songs_view",
  templateUrl: "songs_view.html",
})
export class SongsViewPage {
  public static readonly SONGS_ADD_ACCESS = "addSongs";
  public static readonly SONGS_UPD_ACCESS = "updateSongs";
  public static readonly SONGS_DEL_ACCESS = "deleteSongs";
  public static readonly SONGS_VIEW_ACCESS = "viewSongs";
  private hasAddSongsAccess: boolean = false;
  private hasUpdSongsAccess: boolean = false;
  private hasDelSongsAccess: boolean = false;

  private currentUser: Member;
  private songs$: any;
  private so_id: number;
  private so_text: string;
  private so_title: string;
  private pledge$: any;
  private payment = [];
  private paymenttype = [];
  private styleName: string ="";
  private mbrruns$: any;
  private mbrruns: Hareline;
  private displayPic: boolean = false; // Suppress photos for components
  private page: string = "pledge";
  private member;

  constructor(private configService: ConfigService,private authService: AuthService, public navCtrl: NavController,
              public navParams: NavParams, public alertCtrl: AlertController,
              private db: DbserviceProvider,
  ) {
    console.log("SongsViewPage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");
    this.so_id = this.navParams.get("song").so_id;
    this.so_title = this.navParams.get("song").so_title;
    this.so_text = this.navParams.get("song").so_text;
    if (this.authService.currentUser) {
      this.hasAddSongsAccess = this.db.hasAccess(SongsPage.SONGS_ADD_ACCESS);
      this.hasUpdSongsAccess = this.db.hasAccess(SongsPage.SONGS_UPD_ACCESS);
      this.hasDelSongsAccess = this.db.hasAccess(SongsPage.SONGS_DEL_ACCESS);
    }
  }

  private ionViewWillEnter() {
    console.log("SongsViewPage ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("SongsViewPage onInitPage");
    /*this.db.dbCol({ "action": "select", "mapObject": "songs",
                    "sqlExtended": "where so_id=" + this.so_id + " order by so_order" })
      .subscribe((ret) => {
        this.so_title = ret.so_title;
        this.so_text = ret.so_text;

        // this.navCtrl.pop();
      });*/
  }

  private ngOnDestroy() {
    console.log("SongsViewPage ngOnDestroy");
  }

  private deleteSong() {
    console.log("SongsViewPage deleteMember");
    this.showConfirm("Member", "Do you want to delete the " + this.so_title + " song?");
  }

  private updateSongs() {
    console.log("SongsViewPage updateSongs");
    this.navCtrl.push(SongsUpdatePage, {
      "song": this.navParams.get("song"),
    });
  }

  private showConfirm(title: string, message: string) {
    let confirm = this.alertCtrl.create({
      "buttons": [
        {
          "handler": () => {
            this.db.dbCol({
              "action": "delete", "mapObject": "songs", "so_id": this.so_id,
            }).subscribe((ret) => {
              this.navCtrl.pop();
            });
          },
          "text": "Yes",
        },
        {
          "handler": () => {},
          "text": "No",
        },
      ],
      "message": message,
      "title": title,
    });
    confirm.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/songs/songs_view.ts